export default {
  // 文件庫
  library: {
    field1: '機構文件',
    field2: '應用文件',
    field3: '個人文件',
    field6: '項目文件',
    field4: '我共享的',
    field5: '共享給我的',
    addFolder: '新建文件夾',
    seachFile: '搜索文件',
    filename: '文件名稱',
    updatetime: '最後更新時間',
    updateperson: '更新人',
    sharedperson: '共享人',
    managefolders: '管理文件夾',
    setpermission: '設置權限',
    movefolder: '移動文件夾',
    sharedfile: '共享文件',
    sharedfolder: '共享文件夾',
    delfile: '刪除文件',
    delfolder: '刪除文件夾',
    cancelsharing: '取消共享',
    exitsharing: '退出共享',
    foldername: '文件夾名稱',
    foldertype: '文件夾類型',
    publicTip: '公開（機構所有成員可見此文件夾）',
    privateTip: '私有（只有加入成員可見此文件夾）',
    selectcolor: '選擇顏色',
    deltip: '刪除後此文件夾中的文件和子文件夾將會壹並刪除且不可恢復。',
    moveto: '移動到...',
    selectfolder: '選擇文件夾',
    folderdirectory: '文件夾目錄',
    canceltip: '取消共享後所有共享成員將不可見該文件夾或文件。',
    canceldefine: '你確定要取消共享嗎？',
    exitsharingtip: '退出共享後將不可見該文件夾或文件。',
    exittip: '你確定要退出嗎？',
    member_empty: '成員不能為空',
    selectdirectory: '請選擇目錄',
    noauthority: '您沒有操作該文件夾的權限',
    manage_empty: '管理員不能為空',
    err01: '只能按照模塊搜索數據',
    err02: '只能項目分組搜索數據',
    childmanage: '子管理員',
    name_empty: '文件夾名稱不能為空',
    name_length: '文件夾名稱不能超過12個字符',
    cancel_empty: '共享成員不能為空',
    filedetails: '文件詳情',
    publiclinks: '公開鏈接',
    uploadversion: '上傳新版本',
    fileransfer: '轉為機構文件',
    move: '移動',
    copy: '復制',
    share: '共享',
    sendchat: '發送到聊天',
    magnif: '放大',
    shrink: '縮小',
    rotate: '左旋轉',
    rotate1: '右旋轉',
    full: '全屏查看',
    downlint: '下載記錄',
    hisedition: '歷史版本',
    downperson: '下載人',
    downnum: '下載次數',
    downtime: '最近下載時間',
    currentversion: '當前版本',
    first: '第',
    edition: '版',
    linksharing: '鏈接共享',
    mailsharing: '郵箱共享',
    codesharing: '二維碼共享',
    link: '鏈接地址',
    copyaddress: '復制地址',
    accesspwd: '訪問密碼',
    accessvalidity: '訪問有效期',
    emailaddress: '郵箱地址',
    sharinghistory: '共享歷史',
    scanningtip: '掃描上面的二維碼完成分享',
    copyto: '復制到...',
    delfiletip: '刪除文件後歷史版本也會被壹並刪除，且不可恢復。',
    initiatechat: '發起聊天',
    privatechat: '發起私聊',
    lookgroup: '查看群組',
    sendtip: '發送成功',
    second: '次',
    pwd_error: '密碼只能由4個數字組合',
    email_empty: '郵箱不能為空',
    email_error: '郵箱格式不正確',
    copytoclipboard: '已復制至剪切板',
    sharenote: '給您分享了文件',
    extractpwd: '請輸入提取密碼',
    extractfile: '提取文件',
    downfile: '下載文件',
    share2: '的分享',
    libraryMnage: '文件庫管理',
    libraryNote: '管理企業內部資料，隨時參與團隊成員分享',
    fileset: '文件設置',
    disablefile: '禁用個人文件',
    enablefile: '啟用個人文件',
    companymanag: '機構文件管理員',
    rootdirectory: '根目錄列表',
    companydirectory: '機構文件的根目錄。',
    publicity: '公開性',
    private: '私密',
    public: '公開',
    founder: '創建人',
    setmanage: '設置管理員',
    deltip2: '系統刪除的文件都存儲在這裏，如果繼續刪除將從數據庫中進行刪除，無法再恢復文件。',
    deltip3: '刪除文件將從數據庫進行刪除，刪除後文件將無法恢復，確定要硬刪除該文件嗎？',
    deltime: '刪除時間',
    delpeople: '刪除人'
  }
}
